// saga.ts
import { call, put, takeEvery } from 'redux-saga/effects';
import { createExpenses, deleteExpenses, getExpensesApi, updateExpenses } from '../../api/ExpensesApi'; // Adjust the path as needed
import {
    getExpensesSuccess,
    getExpensesFailure,
    createExpensesSuccess,
    createExpensesFailure,
    updateExpensesSuccess,
    updateExpensesFailure,
    deleteExpensesSuccess,
    deleteExpensesFailure,
} from './actions';

// Saga to handle fetching Expensess
function* fetchExpensesSaga(action: any): Generator<any, any, any> {
    try {
        const data = yield call(getExpensesApi, action.payload);
        yield put(getExpensesSuccess(data));
    } catch (error: any) {
        const errorMessage = error?.response?.data?.meta?.message
            ? error.response
            : error?.message
            ? error.message
            : 'An unexpected error occurred';

        yield put(getExpensesFailure(errorMessage));
    }
}

// // Saga to handle creating a Expenses
function* createExpensesSaga(action: any): Generator<any, any, any> {
    try {
        const data = yield call(createExpenses, action.payload);
        yield put(createExpensesSuccess(data));
    } catch (error: any) {
        const errorMessage = error?.response?.data?.meta?.message
            ? error.response
            : error?.message
            ? error.message
            : 'An unexpected error occurred';

        yield put(createExpensesFailure(errorMessage));
    }
}

// // Saga to handle updating a Expenses
function* updateExpensesSaga(action: any): Generator<any, any, any> {
    try {
        const data = yield call(updateExpenses, action.payload.data, action.payload.id);
        yield put(updateExpensesSuccess(data));
    } catch (error: any) {
        const errorMessage = error?.response?.data?.meta?.message
            ? error.response
            : error?.message
            ? error.message
            : 'An unexpected error occurred';

        yield put(updateExpensesFailure(errorMessage));
    }
}

// // Saga to handle updating a Expenses
function* deleteExpensesSaga(action: any): Generator<any, any, any> {
    try {
        const data = yield call(deleteExpenses, action.payload.id);
        yield put(deleteExpensesSuccess(data));
    } catch (error: any) {
        const errorMessage = error?.response?.data?.meta?.message
            ? error.response
            : error?.message
            ? error.message
            : 'An unexpected error occurred';
        yield put(deleteExpensesFailure(errorMessage));
    }
}

export default function* ExpensesSaga() {
    yield takeEvery('GET_EXPENSES_REQUEST', fetchExpensesSaga);
    yield takeEvery('CREATE_EXPENSES_REQUEST', createExpensesSaga);
    yield takeEvery('UPDATE_EXPENSES_REQUEST', updateExpensesSaga);
    yield takeEvery('DELETE_EXPENSES_REQUEST', deleteExpensesSaga);
}
